import { DEFAULT_VIDEO_SETTINGS } from '@creative/elements/video/video';
import { isColor, isColorProperty, parseColor } from '../color.utils';
import { isContentSpan, unescapeSpanContent } from '../elements/rich-text/utils';
import { isTextNode, isVideoNode } from '../nodes';
export function getParsedCreativeData(serializedCreativeData) {
    return Object.assign(Object.assign({}, serializedCreativeData), { fill: parseColor(serializedCreativeData.fill), elements: serializedCreativeData.elements.map(deserializeElement) });
}
export function deserializeElement(elementDto) {
    const fill = elementDto.fill ? parseColor(elementDto.fill) : undefined;
    const element = Object.assign(Object.assign({}, elementDto), { fill });
    if (elementDto.border) {
        element.border = parseBorder(elementDto.border);
    }
    if (elementDto.shadows) {
        element.shadows = elementDto.shadows.map(parseShadow);
    }
    element.states = elementDto.states.map(parseState);
    if (isTextNode(element) && isTextNode(elementDto)) {
        element.textColor = parseColor(elementDto.textColor);
        element.content = parseTextContent(elementDto);
    }
    if (isVideoNode(element) && isVideoNode(elementDto)) {
        element.videoSettings = parseVideoSettings(elementDto);
    }
    return element;
}
export function mapAssets(elements, preloadAssets) {
    for (const element of elements) {
        if (isTextNode(element)) {
            if (element.content.spans.length > 1 && element.assetId !== undefined) {
                element.font = getFontStyleFromPreloadAssets_m(element.assetId, preloadAssets);
            }
        }
    }
}
function getFontStyleFromPreloadAssets_m(preloadAssetId, preloadAssets) {
    for (const preloadAsset of preloadAssets) {
        if (preloadAsset.id === preloadAssetId) {
            return preloadAsset.value;
        }
    }
    throw new Error('Could not find font style in preload assets.');
}
export function parseState(stateDto) {
    function parse(obj) {
        for (const key in obj) {
            const value = obj[key];
            let newValue;
            if (typeof value === 'object') {
                newValue = parse(value);
            }
            else if (typeof value === 'string' && isColorProperty(key) && isColor(value)) {
                newValue = parseColor(value);
            }
            else {
                newValue = value;
            }
            obj[key] = newValue;
        }
        return obj;
    }
    return parse(stateDto);
}
function parseTextContentStyle(style) {
    const contentStyle = style;
    for (const key in contentStyle) {
        const styleValue = contentStyle[key];
        if (isColorProperty(key) && isColor(styleValue)) {
            contentStyle[key] = parseColor(styleValue);
        }
        if (key === 'textShadow') {
            if (isColorProperty(key) && isColor(styleValue)) {
                contentStyle[key] = parseColor(styleValue);
            }
        }
    }
    return contentStyle;
}
function parseContentSpan(span) {
    if (isContentSpan(span) && span.style.textColor) {
        span.style.textColor = parseColor(span.style.textColor);
    }
    span.content = unescapeSpanContent(span.content);
    return span;
}
function parseTextContent(elementDto) {
    return {
        spans: elementDto.content.spans.map(parseContentSpan),
        style: parseTextContentStyle(elementDto.content.style)
    };
}
function parseVideoSettings(elementDto) {
    const playbackButton = elementDto.videoSettings.playbackButton;
    const streaming = elementDto.videoSettings.streaming || DEFAULT_VIDEO_SETTINGS.streaming;
    const optimization = elementDto.videoSettings.optimization || DEFAULT_VIDEO_SETTINGS.optimization;
    return Object.assign(Object.assign({}, elementDto.videoSettings), { streaming,
        optimization, sizeMode: elementDto.videoSettings.sizeMode, playbackRate: elementDto.videoSettings.playbackRate, playbackButton: Object.assign(Object.assign({}, playbackButton), { color: parseColor(playbackButton.color) }) });
}
function parseBorder(borderDto) {
    return {
        thickness: borderDto.thickness,
        style: borderDto.style || 'solid',
        color: parseColor(borderDto.color)
    };
}
function parseShadow(shadowDto) {
    return Object.assign(Object.assign({}, shadowDto), { color: parseColor(shadowDto.color) });
}
